import { render, staticRenderFns } from "./LayupPanel.vue?vue&type=template&id=12efbfa0&"
import script from "./LayupPanel.vue?vue&type=script&lang=js&"
export * from "./LayupPanel.vue?vue&type=script&lang=js&"
import style0 from "./LayupPanel.vue?vue&type=style&index=0&id=12efbfa0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports